// devConsole.js - Development logging helper
// Only logs when running on localhost, preventing unintended production console output.

function isLocalhost() {
  if (typeof window === "undefined") return false;
  return window.location.hostname === "localhost";
}

const noop = () => {};

const devConsole = {
  log: isLocalhost() ? console.log.bind(console) : noop,
  info: isLocalhost() ? console.info.bind(console) : noop,
  warn: isLocalhost() ? console.warn.bind(console) : noop,
  error: isLocalhost() ? console.error.bind(console) : noop,
  debug: isLocalhost() ? console.debug.bind(console) : noop,
  time: isLocalhost() ? console.time.bind(console) : noop,
  timeEnd: isLocalhost() ? console.timeEnd.bind(console) : noop,
};

export default devConsole;
